import { useMemo } from "react";
import { responsiveFontSizes } from "@mui/material";
import { adaptV4Theme, createTheme } from "@mui/material/styles";
import { buildDocumentThemePalette } from "pages/app/organization/settings/document/general/themeUtils";

const useDocumentLinkTheme = (documentTheme, baseTheme) =>
  useMemo(() => {
    if (!documentTheme) {
      return baseTheme;
    }

    const fallbackThemeProps = {
      primary: baseTheme.palette.primary
    };
    const themeProps = buildDocumentThemePalette(documentTheme, fallbackThemeProps);
    const isLight =
      documentTheme.theme_mode !== null && documentTheme.theme_mode !== undefined
        ? Boolean(documentTheme.theme_mode)
        : baseTheme.palette.mode !== "dark";

    return responsiveFontSizes(
      createTheme(
        adaptV4Theme({
          palette: {
            mode: isLight ? "light" : "dark",
            ...(isLight
              ? {
                  background: {
                    paper: "#f1f1f1",
                    default: "#f1f1f1"
                  }
                }
              : {
                  background: {
                    paper: baseTheme.palette.background.paper,
                    default: baseTheme.palette.background.default
                  }
                }),
            ...themeProps
          }
        })
      )
    );
  }, [baseTheme, documentTheme]);

export default useDocumentLinkTheme;
